// youtubeAPI起動
function onYouTubeIframeAPIReady() {
  const players = [];
  
  for(let i = 0; i < $('.js-card-movie').length; i++) {
    players[i] = new YT.Player($('.js-card-movie')[i].id, {
      events: {
        'onReady': switchMovie
      }
    });
  }
}

// 動画再生切り替え
function switchMovie(event) {
  $(event.target.h).on('mouseenter', function() {
    event.target.mute();
    event.target.playVideo();
  }).on('mouseleave', function() {
    event.target.pauseVideo();
  });
}


$(function () {

  // ブラウザ幅をチェックする
  function checkWindowWidth() {
    initSlider();
  }

  // カード（スライダー）高さを揃える
  function adjustHeightForSlider() {
    $(window).on('load', function() {
      $('.slick-track').each(function(index, sliderElement) {
        let maxHeight = 0;

        $(sliderElement).find($('.slick-slide')).each(function(index, cardElement) {
          const height = $(cardElement).find('.js-card').height();
          if(maxHeight < height) {
            maxHeight = height;
          }
        });
        $(sliderElement).find($('.js-card')).height(maxHeight);
      });
    });
  }

  // スライダー初期設定
  function initSlider() {

    // スライド内の動画を再初期化
    $('.js-slider').on('init', function(slick){
      $('.slick-cloned .js-card-movie').each( function(index, element) {
        element.id = 'youtube-cloned_' + index ;
      })
      if($('.slick-cloned .js-card-movie').length) {
        onYouTubeIframeAPIReady()
      }
    });

    $('.js-slider').not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 3,
      arrows: true,
      prevArrow:'<span class="mod-slider__prev"></span>',
      nextArrow:'<span class="mod-slider__next"></span>',
      responsive: [
        {
          breakpoint: 1140,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 768,
          settings: 'unslick'
        },
      ]
    });
  }

  // 詳細カードを開く
  function openDetailCard() {
    const $window = $(window);

    const $card = $('.js-card')
    const detailCard = '.js-detailCard'

    $card.on('mouseenter', function() {
      const $this = $(this);

      const isPC = $window.width() > 768;
      if (isPC) {
        const $targetDetailCard = $this.children(detailCard)

        const windowWidth = $window.width() * 0.5;
        const cardLeftPosition = $this.offset().left;
        const cardWidth = $this.outerWidth()  + "px";
        const cardHeight = $this.outerHeight() + "px";

        const direction = ((windowWidth > cardLeftPosition) ? 'left':'right');
        $targetDetailCard.css(direction,cardWidth).css('height',cardHeight);
        $targetDetailCard.removeClass('is-left is-right').addClass('is-' + direction);

        $targetDetailCard.fadeIn("fast")
      } else {
        return false;
      }
    }).on('mouseleave', function() {
      const $this = $(this);

      const isPC = $window.width() > 768;
      if (isPC) {
        $this.closest($('.js-card')).children(detailCard).fadeOut("fast")
      } else {
        return false;
      }
    });
  }

  // youtube動画初期化
  function initCardMovie() {
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  // お気に入り操作
  function changeFavorite() {
    const clickType = (( window.ontouchstart!==null ) ? 'click':'touchend');

    $(document).on(clickType,'.js-favorite',function(){
      const $loggedIn = $('.loggedIn');
      const $favoriteBtn = $(this).closest('.js-card').find($('.js-favorite'));

      if($loggedIn.length){
        $favoriteBtn.toggleClass('is-on');
      } else {
        // 未ログインの場合
        alert("お気に入り登録をご利用いただくにはログインしてください。");
        location.href='/mypage/login';
      }
    });
  }

  const isCardMovie = $('.js-card-movie').length;
  if (isCardMovie) {
    initCardMovie();
  }

  const isModuleCard = $('.js-card').length;
  if (isModuleCard) {
    changeFavorite();
    openDetailCard();
  }

  const isModuleSlider = $('.js-slider,.js-slider-sp').length;
  if (isModuleSlider) {
    $(window).on('load resize', checkWindowWidth)
    $(window).on('resize orientationchange', function() {
      $('.js-slider').slick('resize');
    });
    
    adjustHeightForSlider()
  }
});